import { marked } from "marked";
import hljs from "highlight.js";
import DOMPurify from "dompurify";

export default {
  methods: {
    /**
     * 将 md 转成 html
     * @param {*} md
     * @returns
     */
    compileMarkdown(md) {
      if (!md) return "";
      let html = marked(md, {
        highlight: function (code, language) {
          // 检查是否有有效的语言，如果没有，则使用自动检测
          const validLanguage = language && hljs.getLanguage(language) ? language : "plaintext";
          // 使用 highlight.js 的 highlight 方法
          const highlighted = hljs.highlight(code, { language: validLanguage, ignoreIllegals: true });
          // 返回带有 hljs 类名的代码块
          return `<pre><code class="hljs ${highlighted.language}">${highlighted.value}</code></pre>`;
        },
      });
      // 清理 HTML 内容以防止 XSS 攻击
      html = DOMPurify.sanitize(html);
      return html;
    },
    /**
     * 将 markdown 内容转成 带格式的纯文本
     * @param {string} md
     * @returns
     */
    MdRevertText(md) {
      const htmlString = this.compileMarkdown(md);
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlString;
      const formattedText = tempDiv.innerText;
      return formattedText;
    },
  },
};
